import React from 'react';
import { Select } from 'antd';
import { connect } from 'react-redux';

import { notificationTemplateListLoad } from 'store/models/notificationTemplate';
import { FormItem } from 'utils';
import { ListLoadComponent } from 'components/common';

const NotificationTemplateSelect = (props) => {
  return (
    <ListLoadComponent
      apiLoad={notificationTemplateListLoad(props.site.activeDomain)}
      {...props}
      render={({ items }) => {
        const { onChange, disabled, router, authToken, model, dispatch, activeFilter, ...otherProps } = props;
        return (
          <FormItem {...otherProps}>
            <Select
              style={{ width: '100%' }}
              dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
              placeholder="Выберите"
              showSearch={true}
              allowClear={true}
              disabled={disabled}
              filterOption={(input, option) => {
                const children = option.props.children;
                return children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }}
            >
              {!otherProps.required && <Select.Option value={null}>---</Select.Option>}
              {items.map(item => (
                <Select.Option key={`notificationTemplate${item.id}`} value={item.id}>
                  {item.email_subject_tpl}
                </Select.Option>
              ))}
            </Select>
          </FormItem>
        );
      }}
    />
  );
};

const mapState = (state) => ({
  router: state.router,
  authToken: state.auth.token,
  model: state.notificationTemplate,
  site: state.site,
});

export default connect(mapState)(NotificationTemplateSelect);
